import api from "../globals/axios";

import {
  CONVERSATIONS_LIST_ENDPOINT,
  CONVERSATIONS_CREATE_ENDPOINT,
  CONVERSATIONS_ENDPOINT,
  AUDIO_TO_TEXT_ENDPOINT,
} from "../globals/endpoints";

export async function fetchConversations() {
  const response = await api.get(CONVERSATIONS_LIST_ENDPOINT);
  return response.data;
}

export async function createConversation() {
  const response = await api.post(CONVERSATIONS_CREATE_ENDPOINT);
  return response.data;
}

export async function fetchConversation(id) {
  const response = await api.get(CONVERSATIONS_ENDPOINT, {
    params: { conversation_id: id },
  });
  return response.data;
}

export async function sendMessageToAPI(id, message) {
  const response = await api.post(CONVERSATIONS_ENDPOINT, {
    conversation_id: id,
    message: message,
  });
  return response.data;
}

export async function fetchMessagesFromAPI(id) {
  const response = await api.get(`${CONVERSATIONS_ENDPOINT}?conversation_id=${id}`);
  return response.data;
}

export async function sendMessageToConversationAPI(id, payload) {
  const response = await api.post(CONVERSATIONS_ENDPOINT, payload);
  return response.data;
}

export async function uploadAudioToAPI(formData) {
  const response = await api.post(AUDIO_TO_TEXT_ENDPOINT, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.english_text;
}